import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Lang, Trans } from "../utils/lang"
import moment from 'moment'

const BlogCard = ({blok}) => {
  // console.log(blok)
  const lang = Lang()
  const content = typeof blok.content === 'string' ? JSON.parse(blok.content) : blok.content;
  
  const firstPublishedAt = moment(blok.first_published_at)
  const postDate = firstPublishedAt.isValid() ? firstPublishedAt.format('MM/DD/YYYY') : null
  
  return (
    <div className="flex flex-col px-5" {...storyblokEditable(blok)}>
      <a href={`/${blok.full_slug}`} >
        <img className="w-full h-[180px] rounded object-cover" 
        loading="lazy" src={`${content?.image?.filename}/m/600x400`} alt={content?.image?.alt} />
      </a>
      {postDate && <div className="text-xs my-2">{postDate} - Posted</div>}
      <div className="font-serif font-bold my-2"><a href={`/${blok.full_slug}`} >{content.title}</a></div>
        { 
          content.category && content.category?.map((cat, index) => (
            <div className="flex items-center text-green-700" key={index}>
              <div className="mr-2">●</div>
              <a href={`/${cat.fullSlug}`} className="text-sm mr-2">{cat.name}</a>
            </div>
          ))
        }
      
      <div className="tags flex flex-wrap mt-2 justify-start">
        { 
          content.label?.value?.length > 0 && 
          <img className="w-4 h-4 align-middle mr-2" src="/icons/tag.svg" alt="Tag icon"/>
        }
        {
          content.label?.value?.map((tag, index) => (
            <div className="text-blue-700 text-xs border-b-2 border-blue-700 mr-2" key={index}>
              <a href={`${lang}/blogs?label=${tag}`}>{tag}</a>
            </div>
          ))
        }
      </div>
      <div className="text-sm my-4 line-clamp-5">
        {content.excerpt}
      </div>
      <a href={`/${blok.full_slug}`} className="text-blue-800 text-sm flex items-center mt-3 hover:scale-105 transition">{Trans('readMore')}<img className="w-5 h-atuo align-middle ml-1" src="/icons/arrow-right-blue.svg" alt="Arrow right"/></a>
    </div>
  )

}

export default BlogCard
